'use client'

import { StyleProvider } from '@ant-design/cssinjs'
import { App, ConfigProvider, theme as Theme } from 'antd'
import en_US from 'antd/locale/en_US'
import zh_CN from 'antd/locale/zh_CN'
import zh_TW from 'antd/locale/zh_TW'
import React, { useMemo } from 'react'

const { darkAlgorithm } = Theme

export default function AntdProvider({ children, lang }) {
  const theme = {
    cssVar: true,
    algorithm: darkAlgorithm,
    token: {
      colorPrimary: '#FF3C8E',
      // 'sm': '640px'
      screenSM: 640,
      screenSMMax: 767,
      screenSMMin: 640,
      // 'md': '768px'
      screenMD: 768,
      screenMDMax: 1023,
      screenMDMin: 768,
      // 'lg': '1024px'
      screenLG: 1024,
      screenLGMax: 1279,
      screenLGMin: 1024,
      // 'xl': '1280px'
      screenXL: 1280,
      screenXLMax: 1535,
      screenXLMin: 1280,
      // '2xl': '1536px'
      screenXXL: 1536,
      screenXXLMin: 1536,
    },
    components: {
      Form: {
        colorError: '#FF6E6E',
        itemMarginBottom: 20,
      },
      Drawer: {
        paddingLG: 0,
      },
    },
  }

  const locale = useMemo(() => {
    switch (lang) {
      case 'zh-CN':
        return zh_CN
      case 'zh-TW':
        return zh_TW
      default:
        return en_US
    }
  }, [lang])

  return (
    <StyleProvider layer={true}>
      <ConfigProvider theme={theme} locale={locale}>
        <App>{children}</App>
      </ConfigProvider>
    </StyleProvider>
  )
}
